
(function($) { 
    
    $(document).ready(function() {

//if ($(".edit-post-sidebar .editor-post-excerpt textarea").length > 0) {
    /*
    $(".editor-post-excerpt textarea").attr('maxlength', 3);  
    $("#inspector-textarea-control-0").attr('maxlength', 3);  
    $("#inspector-textarea-control-1").attr('maxlength', 3);  
    */
    //}
    $('.editor-post-excerpt textarea').keydown(function(e) {
        if (this.value.length > 3) 
            if ( !(e.which == '46' || e.which == '8' || e.which == '13') ) // backspace/enter/del
                e.preventDefault();
    });

});
})( jQuery ); 